export default __webpack_public_path__ + "static/media/3.4e3bf621.webp";